import { createFileRoute } from '@tanstack/react-router';
import { isPermissionFull } from '@/features/login/util/permission';
import { validateRoute } from '@/router/util';

export const Route = createFileRoute('/a/secundario')({
    beforeLoad: () =>
        validateRoute({
            fintech: true,
            validatePermission: ({ upp_configuracao_configuracao }) =>
                isPermissionFull(upp_configuracao_configuracao),
        }),
});
